module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-12.dee3c311.png";